import React from "react";

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { ExpandMore as ExpandMoreIcon } from '@vedmarket/ui-kit';

import {COLORS} from "../../../../../../../config/constants";

import InvoiceTitle from "./components/invoiceTitle";
import InvoiceDetails from "./components/invoiceDetails";

import './invoice.scss';
import {useDemoBankInvoiceAccordion} from "components/cabinet/demo/steps/payment/use-payment";

const Invoice = ({invoice, index, refetch}: BankCommissionInvoiceProps) => {

  const demoPlayback = useDemoBankInvoiceAccordion(invoice.id)

  return <div
    className='invoice bank-commission-invoice'
    {...demoPlayback.invoiceProps}
  >
    <Accordion sx={{
      marginBottom: 0,
      border: `1px solid ${COLORS.SLIGHTLY_GRAY}`,
      boxShadow: 'none',
      '&.Mui-expanded': {
        marginBottom: 0,
      },
    }} {...demoPlayback.accordionProps}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon style={{
          width: '24px',
          height: '24px',
          fill: 'currentColor',
        }}/>}
        sx={{
          padding: '24px',
          minHeight: '74px',
          '&.Mui-expanded': {
            minHeight: '74px',
            paddingBottom: '23px',
          },
          '& .MuiAccordionSummary-content, & .MuiAccordionSummary-content.Mui-expanded': {
            margin: 0,
            minWidth: 0,
          },
          '& .MuiAccordionSummary-expandIconWrapper': {
            color: COLORS.LIGHT_ACTION,
            alignSelf: 'flex-start',
            marginTop: '1px',
          },
        }}
      >
        <InvoiceTitle invoice={invoice} index={index}/>
      </AccordionSummary>
      <AccordionDetails sx={{padding: '24px'}}>
        {invoice.price_total && (
          <InvoiceDetails
            invoiceNumber={invoice.invoice_num}
            invoiceId={invoice.id.toString()}
            refetch={refetch}
            invoiceAmount={invoice.price_total}
          />
        )}
      </AccordionDetails>
    </Accordion>
  </div>
}

export default Invoice
